import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { SelectPickerField } from 'components/form/selectpicker'
import { MissingTokensIcon } from 'pages/admin/users/users'
import * as R from 'ramda'

export const getStyle = show => ({ [show ? '' : 'display']: 'none' })

const ConfigureOwnership = ({
  tenants,
  users,
  disabled,
  experiencePlatform
}) => {
  const getPlatformUsers = R.cond([
    [
      R.equals('twitter'),
      () => R.filter(({ id }) => !R.startsWith('FB-', id))(users)
    ],
    [
      R.equals('instagram'),
      () => R.filter(({ id }) => R.startsWith('FB-', id))(users)
    ],
    [
      R.equals('facebook'),
      () => R.filter(({ id }) => R.startsWith('FB-', id))(users)
    ],
    [R.T, () => users]
  ])

  return (
    <div className='form-group darkPanel' style={getStyle(tenants.length)}>
      <div className='col-md-12'>
        <div className='portlet light'>
          <div className='portlet-title'>
            <div className='caption'>
              <i className='fa fa-users font-green-haze hidden-xs' />
              <span className='caption-subject bold font-green-haze uppercase'>
                Experience Ownership
              </span>
              &nbsp;
              <span className='caption-helper hidden-xs'>
                You must complete all fields in this section
              </span>
            </div>
          </div>

          <div className='portlet-body'>
            <p className='visible-xs'>
              You must complete all fields in this section
            </p>
            <div className='form-group'>
              <label className='col-sm-2 control-label'>User</label>
              <div className='col-sm-6 col-md-5'>
                <Field
                  component={SelectPickerField}
                  name='ownerId'
                  title='Select a user'
                  className='form-control'
                  data-live-search='true'
                  data-size='10'
                  disabled={disabled}
                >
                  {getPlatformUsers(experiencePlatform).map(user => (
                    <option key={user.id} value={user.id}>
                      <div className='user-select-option'>
                        {user.screenName}
                        {!user.hasTwitterTokens && <MissingTokensIcon />}
                      </div>
                    </option>
                  ))}
                </Field>
              </div>
            </div>
            <div className='form-group'>
              <label className='col-sm-2 control-label'>Partner</label>
              <div className='col-sm-6 col-md-5'>
                <Field
                  component={SelectPickerField}
                  name='tenantId'
                  title='Select a partner'
                  className='form-control'
                  data-live-search='true'
                  data-size='10'
                  disabled={disabled}
                >
                  {tenants.map(tenant => (
                    <option value={tenant.id} key={tenant.id}>
                      {tenant.name}
                    </option>
                  ))}
                </Field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

ConfigureOwnership.propTypes = {
  tenants: PropTypes.array,
  users: PropTypes.array,
  disabled: PropTypes.bool,
  experiencePlatform: PropTypes.string
}

export default ConfigureOwnership



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-ownership/configure-ownership.js